"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const KeyboardArrowDown_1 = __importDefault(require("@material-ui/icons/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@material-ui/icons/KeyboardArrowUp"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
const CollapsibleTableRow = (_a) => {
    var { children, columnSpan = 1, expandDetails, onClick, color = 'none', expandcolor = 'none', spacing = '10px', style } = _a, commonProps = __rest(_a, ["children", "columnSpan", "expandDetails", "onClick", "color", "expandcolor", "spacing", "style"]);
    const [open, setOpen] = react_1.default.useState(false);
    const expandClick = () => {
        const updatedOpen = !open;
        setOpen(updatedOpen);
        /* istanbul ignore else */
        if (typeof onClick === 'function') {
            onClick(updatedOpen);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableRow_1.default, Object.assign({}, commonProps, { style: Object.assign(Object.assign({}, style), { background: open ? expandcolor : color }) }),
            children,
            react_1.default.createElement(TableCell_1.default, { style: {
                    borderBottom: '0px',
                    padding: spacing,
                } },
                react_1.default.createElement(IconButton_1.default, { onClick: expandClick, "aria-label": open ? 'Collapse' : 'Expand' }, open ? react_1.default.createElement(KeyboardArrowUp_1.default, null) : react_1.default.createElement(KeyboardArrowDown_1.default, null)))),
        react_1.default.createElement(TableRow_1.default, { style: {
                background: expandcolor,
            } },
            react_1.default.createElement(TableCell_1.default, { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: columnSpan },
                react_1.default.createElement(Collapse_1.default, { in: open, timeout: "auto", unmountOnExit: true },
                    react_1.default.createElement(Box_1.default, { margin: "xxs" }, expandDetails))))));
};
exports.default = CollapsibleTableRow;
